<template>
  <div>
    <el-form :model="formData" :rules="rules" ref="form" class="main-form-scroll">
      <el-form-item :label="$t('appParams.value')" prop="nameSelected">
        <el-input v-model="formData.nameSelected"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="bottom-buttons">
      <div></div>
      <div>
        <el-button class="button-cancel" type="plain" @click="cancelClick">{{ $t('appParams.cancel') }}</el-button>
        <el-button class="button-confirm" type="success" @click="okClick">OK</el-button>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";

export default {
  props: {
    type: String,
  },
  data() {
    return {
      formData: {
        nameSelected: null,
      },
      rules: {
        nameSelected: [
          {
            required: true,
            message:  this.$t('appParams.enterParamName') ,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    populateForm() {
      this.formData.nameSelected = this.getCurInfo.name;
    },
    okClick() {
      if (!!this.formData.nameSelected)
        this.formData.nameSelected = this.formData.nameSelected.trim();
      this.$refs["form"].validate((valid, object) => {
        if (valid) {
          this.$emit("data", this.formData);
        } else {
          this.$message.error(this.$t('appParams.requiredFieldsNotSelected'));
        }
      });
    },
    cancelClick() {
      this.$emit("close");
    },
  },
  computed: {
    ...mapGetters(["getCurInfo"]),
  },
  created() {
    if (this.type === "edit") {
      //console.log(this.getCurInfo);
      this.populateForm();
    }
    this.$emit("input", this.formData);
  },
};
</script>

